import type { IconSvgObject } from './types';

const TriangleDashIcon: IconSvgObject = [
  ["path", { d: "M20.4152 21C21.2904 21 22 20.2904 22 19.4152C22 19.143 21.9299 18.8754 21.7965 18.6382L21.5886 18.2686M3.58485 21C2.70956 21 2 20.2904 2 19.4152C2 19.143 2.0701 18.8754 2.20353 18.6382L2.41138 18.2686M13.8438 4.5L13.4903 3.87158C13.1874 3.33318 12.6177 3 12 3C11.3823 3 10.8126 3.33318 10.5097 3.87158L10.1562 4.5M15.5312 7.5L16.6562 9.5M8.46875 7.5L7.34375 9.5M18.625 13L19.75 15M5.375 13L4.25 15M16 21H14M10 21H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default TriangleDashIcon;
